import styled from 'styled-components'
import { Checkbox, Form, Input, Modal, Select } from 'antd'
import { BasTitle, IconFont } from '@/components'
import { useEffect, useMemo, useState } from 'react'
import { t } from '@/i18n'

/**
 * CreateReport 参数总结
 * @visible       弹窗是否显示
 * @onCancel      关闭弹窗
 * @showSelect    报表模板是否展示
 * @onConfirm     接收返回值
 * @templateType  模板类型 钓鱼:1, 威胁情报:2, 邮件网关:3, WAF:4, 威胁防护:5, 邮箱收集:6, 攻击面发现:8, 攻击编排：10
 */

type ValuesType = {
  [key: string]: string | any[] | number | boolean | undefined
}
interface FormProps extends ValuesType {
  report_name: string
  report_type: string
  template_type: string[] | number[]
  campaign_type: number
  include_device_logs?: boolean
  campaign_ids?: string[]
}
interface CreateReportProps {
  visible: boolean
  showSelect?: boolean
  templateType: number
  multiple?: boolean
  selectItem?: any
  createLoading?: boolean
  onConfirm: (values: FormProps) => void
  onCancel: (e: React.MouseEvent<HTMLElement>) => void
}

export const CreateReport = (props: CreateReportProps) => {
  const [createForm] = Form.useForm()

  // 监听关联任务的变化
  const campaignIds = Form.useWatch('campaign_ids', createForm)

  // 根据关联任务数量过滤文件类型
  const filterFileTypeByTaskCount = (fileTypes: any[]) => {
    const selectedTaskCount = campaignIds?.length || 0
    if (selectedTaskCount > 1) {
      // 过滤掉 Word(type: 3) 和 PDF(type: 4)
      return fileTypes.filter(item => item.type !== 3 && item.type !== 4)
    }
    return fileTypes
  }

  // const menuList = useMemo(
  //   () => [
  //     {
  //       id: 8,
  //       name: '攻击面发现',
  //       template_list: [
  //         {
  //           template_name: '全部资产',
  //           file_type: [{ type: 3, name: 'Word' }],
  //         },
  //         {
  //           template_name: '仅我的资产',
  //           file_type: [{ type: 4, name: 'PDF' }],
  //         },
  //       ],
  //     },
  //     {
  //       id: 6,
  //       name: '邮箱收集',
  //       template_list: [
  //         {
  //           template_name: '',
  //           file_type: [{ type: 2, name: 'Excel' }], //邮箱收集没有html
  //         },
  //       ],
  //     },
  //     {
  //       id: 1,
  //       name: '钓鱼邮件',
  //       template_list: [
  //         {
  //           template_name: '默认报表模板',
  //           file_type: props?.selectItem?.length > 1 ? [] : [{ type: 1, name: 'HTML' }],
  //         },

  //         {
  //           template_name: '详情信息模板',
  //           file_type: [{ type: 2, name: 'Excel' }],
  //         },
  //       ],
  //     },
  //     {
  //       id: 2,
  //       name: '威胁情报',
  //       template_list: [
  //         {
  //           template_name: '默认报表模板',
  //           file_type: props?.selectItem?.length > 1 ? [] : [{ type: 1, name: 'HTML' }],
  //         },
  //         {
  //           template_name: '详情信息模板',
  //           file_type: [{ type: 2, name: 'Excel' }],
  //         },
  //       ],
  //     },
  //     {
  //       id: 3,
  //       name: '邮件网关',
  //       template_list: [
  //         {
  //           template_name: '默认报表模板',
  //           file_type: props?.selectItem?.length > 1 ? [] : [{ type: 1, name: 'HTML' }],
  //         },
  //         {
  //           template_name: '详情信息模板',
  //           file_type: [{ type: 2, name: 'Excel' }],
  //         },
  //       ],
  //     },
  //     {
  //       id: 4,
  //       name: 'WAF',
  //       template_list: [
  //         {
  //           template_name: '默认报表模板',
  //           file_type:
  //             props?.selectItem?.length > 1
  //               ? [
  //                   { type: 2, name: 'Excel' },
  //                   { type: 3, name: 'Word' },
  //                 ]
  //               : [
  //                   { type: 2, name: 'Excel' },
  //                   // { type: 1, name: 'HTML' },
  //                   { type: 3, name: 'Word' },
  //                   { type: 4, name: 'Pdf' },
  //                 ],
  //         },
  //       ],
  //     },
  //     {
  //       id: 5,
  //       name: '威胁防护',
  //       template_list: [
  //         {
  //           template_name: '默认报表模板',
  //           file_type:
  //             props?.selectItem?.length > 1
  //               ? [
  //                   { type: 2, name: 'Excel' },
  //                   { type: 3, name: 'Word' },
  //                 ]
  //               : [
  //                   { type: 2, name: 'Excel' },
  //                   // { type: 1, name: 'HTML' },
  //                   { type: 3, name: 'Word' },
  //                   { type: 4, name: 'Pdf' },
  //                 ],
  //         },
  //       ],
  //     },
  //     {
  //       id: 9,
  //       name: '终端安全',
  //       template_list: [
  //         {
  //           template_name: '详情信息模板',
  //           file_type:
  //             props?.selectItem?.length > 1
  //               ? [
  //                   { type: 2, name: 'Excel' },
  //                   { type: 3, name: 'Word' },
  //                 ]
  //               : [
  //                   { type: 2, name: 'Excel' },
  //                   // { type: 1, name: 'HTML' },
  //                   { type: 3, name: 'Word' },
  //                   { type: 4, name: 'Pdf' },
  //                 ],
  //         },
  //       ],
  //     },
  //     {
  //       id: 11,
  //       name: '容器安全',
  //       template_list: [
  //         {
  //           template_name: '详情信息模板',
  //           file_type: [{ type: 2, name: 'Excel' }],
  //         },
  //       ],
  //     },
  //     {
  //       id: 7,
  //       name: '数据防泄漏',
  //       template_list: [
  //         {
  //           template_name: '详情信息模板',
  //           file_type:
  //             props?.selectItem?.length > 1
  //               ? [{ type: 2, name: 'Excel' }]
  //               : [
  //                   { type: 2, name: 'Excel' },
  //                   // { type: 1, name: 'HTML' },
  //                 ],
  //         },
  //       ],
  //     },
  //     {
  //       id: 10,
  //       name: '攻击编排',
  //       template_list: [
  //         {
  //           template_name: '详情信息模板',
  //           file_type: [{ type: 1, name: 'HTML' }],
  //         },
  //       ],
  //     },
  //   ],
  //   [props.selectItem],
  // )

  const menuList = useMemo(
    () => [
      {
        id: 8,
        name: t('攻击面发现'),
        template_list: [
          {
            template_name: t('全部资产'),
            file_type: [{ type: 3, name: 'Word' }],
          },
          {
            template_name: t('仅我的资产'),
            file_type: [{ type: 4, name: 'PDF' }],
          },
        ],
      },
      {
        id: 6,
        name: t('邮箱收集'),
        template_list: [
          {
            template_name: '',
            file_type: [{ type: 2, name: 'Excel', hasLog: false }], //邮箱收集没有html
          },
        ],
      },
      {
        id: 1,
        name: t('钓鱼邮件'),
        template_list: [
          {
            template_name: t('详情信息模板'),
            file_type: [{ type: 2, name: 'Excel', hasLog: false }],
          },
        ],
      },
      {
        id: 2,
        name: t('威胁情报'),
        template_list: [
          {
            template_name: t('详情信息模板'),
            file_type: [{ type: 2, name: 'Excel', hasLog: true }],
          },
        ],
      },
      {
        id: 3,
        name: t('邮件网关'),
        template_list: [
          {
            template_name: t('详情信息模板'),
            file_type: [{ type: 2, name: 'Excel', hasLog: true }],
          },
        ],
      },
      {
        id: 4,
        name: 'WAF',
        template_list: [
          {
            template_name: t('默认报表模板'),
            file_type: [
              { type: 2, name: 'Excel', hasLog: true },
              { type: 3, name: 'Word' },
              { type: 4, name: 'Pdf' },
            ],
          },
        ],
      },
      {
        id: 5,
        name: t('流量安全'),
        template_list: [
          {
            template_name: t('默认报表模板'),
            file_type: [
              { type: 2, name: 'Excel', hasLog: true },
              { type: 3, name: 'Word' },
              { type: 4, name: 'Pdf' },
            ],
          },
        ],
      },
      {
        id: 9,
        name: t('终端安全'),
        template_list: [
          {
            template_name: t('详情信息模板'),
            file_type: [
              { type: 2, name: 'Excel', hasLog: true },
              { type: 3, name: 'Word' },
              { type: 4, name: 'Pdf' },
            ],
          },
        ],
      },
      {
        id: 11,
        name: t('容器安全'),
        template_list: [
          {
            template_name: t('详情信息模板'),
            file_type: [{ type: 2, name: 'Excel', hasLog: true }],
          },
        ],
      },
      {
        id: 7,
        name: t('数据防泄漏'),
        template_list: [
          {
            template_name: t('详情信息模板'),
            file_type: [{ type: 2, name: 'Excel', hasLog: false }],
          },
        ],
      },
      {
        id: 10,
        name: t('攻击编排'),
        template_list: [
          {
            template_name: t('详情信息模板'),
            file_type: [{ type: 1, name: 'HTML' }],
          },
        ],
      },
    ],

    [props.selectItem],
  )

  const [selectKey, setSelectKey] = useState(0)

  const {
    visible = false,
    showSelect = false,
    multiple = false,
    templateType,
    selectItem,
    createLoading,
    onConfirm,
    onCancel,
  } = props
  const TemplateKey = useMemo(() => {
    let index = menuList.findIndex(item => item.id === templateType)
    createForm.setFieldsValue({
      report_name: '',
      report_type: menuList?.[index]?.template_list[0].template_name,
      template_type: showSelect
        ? menuList?.[index]?.template_list[0].file_type.map(item => item.type)
        : menuList?.[index]?.template_list?.map(item => item.file_type.map(e => e.type)).flat(),
      include_device_logs: false,
    })
    return index
  }, [templateType])

  useEffect(() => {
    createForm.setFieldsValue({
      report_name: '',
      report_type: menuList?.[TemplateKey]?.template_list[0].template_name,
      template_type: showSelect
        ? menuList?.[TemplateKey]?.template_list[0].file_type.map(item => item.type)
        : menuList?.[TemplateKey]?.template_list
            ?.map(item => item.file_type.map(e => e.type))
            .flat(),
      include_device_logs: false,
      campaign_ids: selectItem
        ?.filter(
          i =>
            Number(i?.result_status) == 3 ||
            Number(i?.result_status) == 5 ||
            i?.executed_plugin_num > 0,
        )
        .map(i => i.id),
    })
  }, [visible, selectItem])

  return (
    <ReportTemplate
      visible={visible}
      centered
      title={<BasTitle title={t('生成报表')} />}
      onOk={() => {
        createForm.submit()
      }}
      onCancel={onCancel}
      afterClose={() => {
        setSelectKey(0)
        createForm.setFieldsValue({
          report_name: '',
          report_type: menuList?.[TemplateKey]?.template_list[0].template_name,
          template_type: showSelect
            ? menuList?.[TemplateKey]?.template_list[0].file_type.map(item => item.type)
            : menuList?.[TemplateKey]?.template_list
                ?.map(item => item.file_type.map(e => e.type))
                .flat(),
          include_device_logs: false,
          campaign_ids: [],
        })
      }}
      confirmLoading={createLoading}
    >
      <Form
        form={createForm}
        layout="vertical"
        onFinish={(e: FormProps) => {
          let attachmentType =
            e.campaign_ids?.length && e.campaign_ids?.length > 1 ? [2] : e.template_type
          onConfirm({ ...e, template_type: attachmentType, campaign_type: templateType })
        }}
      >
        <Form.Item
          name="report_name"
          label={t('报表名称')}
          rules={[{ required: true }, { max: 30, message: t('报表名称最多30字') }]}
        >
          <Input placeholder={t('请输入报表名称')} />
        </Form.Item>
        {showSelect && (
          <Form.Item name="report_type" label={t('报表模板')}>
            <Select
              placeholder={t('请选择报表模板')}
              onChange={(_, d: any) => {
                setSelectKey(d.key)
                createForm.setFieldsValue({
                  template_type: menuList?.[TemplateKey]?.template_list[d.key].file_type.map(
                    item => item.type,
                  ),
                  include_device_logs: false,
                })
              }}
            >
              {menuList?.[TemplateKey]?.template_list?.map((item, i) => (
                <Select.Option key={i} value={item.template_name}>
                  {item.template_name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        )}
        {multiple && (
          <>
            <Form.Item
              name="campaign_ids"
              label={t('关联任务')}
              tooltip={{
                title: t('支持导出已完成和存在部分结果的中断任务'),
                getPopupContainer: () => document.body,
                icon: (
                  <IconFont type="icon-tishi" style={{ color: '#909090', marginLeft: '2px' }} />
                ),
              }}
              rules={[{ required: true, message: t('请选择关联任务') }]}
            >
              <Select mode="multiple" placeholder={t('请选择关联任务')} showSearch>
                {selectItem
                  ?.filter(
                    i =>
                      Number(i?.result_status) == 3 ||
                      Number(i?.result_status) == 5 ||
                      i?.executed_plugin_num > 0,
                  )
                  .map(item => (
                    <Select.Option
                      key={item.id}
                      value={item.id}
                      // disabled={
                      //   Number(item.result_status) !== 3 && Number(item.result_status) !== 5
                      // }
                    >
                      {item.task_name}-{item.id}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
            <div style={{ marginBottom: '10px' }}>
              <div style={{ marginBottom: '5px' }}>
                <IconFont
                  type="icon-jinggao_jinggao"
                  style={{ color: '#FFAD31', marginRight: '6px' }}
                />

                <span className="info" style={{ color: '#9D5425', fontSize: '14px' }}>
                  {t('支持导出已完成和存在部分结果的中断任务')}
                </span>
              </div>
              {selectItem
                ?.filter(
                  item =>
                    Number(item.result_status) !== 3 &&
                    Number(item.result_status) !== 5 &&
                    !item?.executed_plugin_num,
                )
                .map((item, index) => (
                  <div
                    style={{
                      color: '#9D5425',
                      fontSize: '14px',
                      marginLeft: '20px',
                      marginBottom: '8px',
                    }}
                    key={index}
                  >
                    {item.task_name}（{item.id}
                    {t('）不可导出')}
                  </div>
                ))}
            </div>
          </>
        )}
        <Form.Item
          name="template_type"
          label={t('报表格式')}
          rules={[{ required: true, message: t('请选择报表格式') }]}
        >
          <Checkbox.Group>
            {showSelect ? (
              <>
                {filterFileTypeByTaskCount(
                  menuList?.[TemplateKey]?.template_list[selectKey].file_type || [],
                ).map((item, index) => (
                  <div
                    key={index}
                    style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}
                  >
                    <Checkbox value={item.type}>{item.name}</Checkbox>
                    {item.type === 2 && item.hasLog && (
                      <Form.Item
                        name="include_device_logs"
                        noStyle
                        rules={[{ required: true, message: t('请选择告警日志类型') }]}
                        style={{ flex: 1, marginLeft: '12px' }}
                      >
                        <Select placeholder={t('请选择')} style={{ flex: 1, marginLeft: '12px' }}>
                          <Select.Option value={false}>{t('无设备告警日志')}</Select.Option>
                          <Select.Option value>{t('有设备告警日志')}</Select.Option>
                        </Select>
                      </Form.Item>
                    )}
                  </div>
                ))}
              </>
            ) : (
              menuList?.[TemplateKey]?.template_list?.map((item, index) =>
                filterFileTypeByTaskCount(item.file_type).map((fileType, i) => (
                  <div
                    key={`${index}-${i}`}
                    style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}
                  >
                    <Checkbox value={fileType.type}>{fileType?.name}</Checkbox>
                    {fileType.type === 2 && fileType.hasLog && (
                      <Form.Item
                        name="include_device_logs"
                        noStyle
                        rules={[{ required: true, message: t('请选择告警日志类型') }]}
                      >
                        <Select placeholder={t('请选择')} style={{ flex: 1, marginLeft: '12px' }}>
                          <Select.Option value={false}>{t('无设备告警日志')}</Select.Option>
                          <Select.Option value>{t('有设备告警日志')}</Select.Option>
                        </Select>
                      </Form.Item>
                    )}
                  </div>
                )),
              )
            )}
          </Checkbox.Group>
        </Form.Item>
      </Form>
    </ReportTemplate>
  )
}
const ReportTemplate = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
    position: relative;

    .ant-modal-close {
      width: 36px;
      height: 36px;
      background: #d8d6f4;
      box-shadow: -1px 4px 10px 0px #c7c7c7;
      border-radius: 6px;
      border: none;
      color: #4238c9;
      font-size: 16px;
      font-weight: 500;
      position: absolute;
      right: -8px;
      top: -8px;
      transition: transform 0.3s ease;

      &:hover {
        transform: translate(-18px, 18px);
        box-shadow: 0 0 0 0;
      }

      .ant-modal-close-x {
        width: 100%;
        height: 100%;
        line-height: 36px;
        text-align: center;
      }
    }

    .ant-modal-header {
      height: 56px;
      background: #f2f0ff;
      border-bottom: none;
      margin: 0;
    }
    .ant-checkbox-group {
      display: block;
    }
  }
`
